<template>
  <InfoPage>
    <h1 class="display-2 mt-2 mt-md-6 mt-lg-12 mb-6 text-center">{{ $t("formulaireDon.remerciementTitre") }}</h1>
    <div v-html="$t('formulaireDon.remerciementParagrapheMensuel')"></div>
    <div v-html="$t('transactionRealisee')"></div>
  </InfoPage>
</template>

<script>
import InfoPage from "@/layouts/InfoPage"

export default {
  components: {
    InfoPage
  }
}
</script>

<style>
</style>